

export default function Emty(){
      return <div className="w-full h-c70 7:h-20"></div>
}